import { precallMemoryConstants } from "@data/constants/precallMemoryConstants"

/**
 * Le matériel a été vérifié de bout en bout, dans cette configuration.
 *
 * À n'appeler que si TOUTES les étapes sont au vert. Une étape passée n'est pas
 * une étape vérifiée : la mémoriser reviendrait à dispenser demain d'un test
 * qu'on n'a pas réussi aujourd'hui.
 *
 * `components` est optionnel et purement diagnostique (quel morceau a bougé
 * la prochaine fois que le raccourci échoue) — `signature` seule reste ce qui
 * décide du raccourci.
 */
export function rememberDeviceCheck({ signature, components } = {}) {
    return { type: precallMemoryConstants.REMEMBER_DEVICE_CHECK, signature, components }
}

/** Le souvenir ne vaut plus rien — voir le reducer pour le seul cas concerné. */
export function forgetDeviceCheck() {
    return { type: precallMemoryConstants.FORGET_DEVICE_CHECK }
}
